export enum OnboardingNavigationStates {
  LANDING = "LANDING",
  AADHAR = "AADHAR",
  AADHAR_OTP = "AADHAR_OTP",
  PHONE_NUMBER = "PHONE_NUMBER",
  PHONE_NUMBER_OTP = "PHONE_NUMBER_OTP",
  SETUP_HPR_ID = "SETUP_HPR_ID",
  HPR_ID_SUCCESSFUL = "HPR_ID_SUCCESSFUL",
  HFR_FORM = "HFR_FORM",
  HFR_CREATION_COMPLETED = "HFR_CREATION_COMPLETED",
}

export enum HFROnboardingSubStates {
  EXISTING_HFR_FORM = "EXISTING_HFR_FORM",
  CONFIRM_HFR = "CONFIRM_HFR",
}
